<template>
  <div class="notice flex-center" v-show="showNoticeList.length">
    <div class="notice-wrap" @click.stop="noticeDetailHandle">
      <Icon class="notice-icon" name="speaker-one" />
      <div class="notice-container">
        <div class="notice-swiper" :key="lang">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(notice, index) in showNoticeList"
              :key="index"
            >
              <p class="notice-text">{{ notice.notice }}</p>
            </div>
          </div>
        </div>
      </div>
      <Icon class="jump-icon" :class="{ active: isShowDetail }" name="down" />
    </div>
    <div
      class="notice-detail"
      v-clickoutside="hideNoticeDetail"
      v-show="isShowDetail"
    >
      <div
        class="notice-item"
        v-for="(notice, index) in showNoticeList"
        :key="index"
        @click="clickNotice(notice)"
      >
        <em class="notice-sign"></em>
        <span class="notice-content">
          {{ notice.notice }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import { mapState } from 'vuex';
import clickOutside from '../../../diractives/officialStore/clickOutside';
import {
  clickButton,
  popupType,
  showPopup
} from '@plugins/biPoint/_configWebstoreV3';
import { sdkOpenLink } from '@utiles/officialStore/sdkCtrl';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
export default {
  name: 'Notice',
  data() {
    return {
      swiper: null,
      isShowDetail: false
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      lampList: state => state.activity.lampList
    }),
    showNoticeList() {
      // 判断列表每个notice.basic?.notice不为空的情况，合成一个新数组
      const list = [];
      this.lampList.forEach(item => {
        if (item?.basic?.notice) {
          list.push(item?.basic);
        }
      });
      return list;
    }
  },
  watch: {
    showNoticeList: {
      handler(newVal) {
        if (!newVal.length) return;
        this.$nextTick(() => {
          this.initSwiper();
        });
      }
    }
  },
  methods: {
    initSwiper() {
      try {
        this.swiper && this.swiper.destroy();
        this.swiper = new Swiper('.notice-swiper', {
          loop: true,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false
          },
          direction: 'vertical',
          slidesPerView: 1
        });
      } catch (err) {
        console.error(err);
      }
    },
    noticeDetailHandle() {
      this.isShowDetail = !this.isShowDetail;
      if (this.isShowDetail) {
        showPopup(popupType.noticePopup);
      }
    },
    hideNoticeDetail() {
      this.isShowDetail = false;
    },
    clickNotice(notice) {
      if (notice?.redirectLink) {
        sdkOpenLink({
          link: getGlobalGetGotoLink({ link: notice.redirectLink })
        });
      }
      this.hideNoticeDetail();
    }
  },
  directives: {
    clickoutside: clickOutside
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopup/_dimen.scss';
.notice {
  width: 100%;
  background-color: #ffffff;
  position: relative;

  .notice-wrap {
    cursor: pointer;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    height: 85px;
    padding: 0 40px;
    border-bottom: 1px solid #f4f4f4;

    .notice-icon {
      margin: 0 15px 0 10px;
      width: 44px;
      height: 36px;
      color: $themeColor;
    }
    .notice-container {
      width: 100%;
      height: 85px;
      font-size: 24px;
      line-height: 1.2;
      color: #333333;
      overflow: hidden;

      .notice-swiper {
        height: 100%;
        .swiper-slide {
          display: flex;
          align-items: center;

          .notice-text {
            font-size: 24px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
    .jump-icon {
      float: right;
      width: 30px;
      height: 30px;
      margin-left: 10px;

      &.active {
        transform: rotate(180deg);
      }
    }
  }
  .notice-detail {
    z-index: 9;
    overflow-y: scroll;
    width: 100%;
    max-height: 300px;
    position: absolute;
    top: 110px;
    border-radius: 20px;
    box-shadow: 0 0 30px rgba(51, 51, 51, 0.2);
    background-color: #ffffff;
    font-size: 24px;
    padding: 0 40px 20px 40px;
    box-sizing: border-box;

    .notice-item {
      display: flex;
      align-items: baseline;
      cursor: pointer;
      margin-top: 30px;

      .notice-sign {
        flex-shrink: 0;
        display: inline-block;
        width: 12px;
        height: 12px;
        background-color: $themeColor;
        border-radius: 50%;
        margin-right: 10px;
      }

      .notice-content {
        width: 100%;
        word-break: break-word;
        font-size: 24px;
        display: inline-block;
        line-height: 1.5;
      }
    }
    .notice-item :hover {
      text-decoration: underline;
    }
  }
}

@media screen and (orientation: landscape) {
  .notice {
    .notice-wrap {
      display: flex;
      align-items: center;
      width: 1200px;
      padding: 0 40px;
      border-bottom: none;

      .notice-icon {
        margin-left: 0;
        width: 36px;
        height: 30px;
      }
      .notice-container {
        height: 85px;
        font-size: 20px;
        .notice-swiper {
          height: 100%;
          .swiper-slide {
            height: 85px;
            .notice-text {
              font-size: 20px;
            }
          }
        }
      }
      .jump-icon {
        width: 26px;
        height: 26px;
      }
    }
    .notice-detail {
      width: 1200px;
      top: 100px;
      .notice-item {
        .notice-content {
          font-size: 20px;
        }
      }
    }
  }
}
</style>
